import { render, staticRenderFns } from "./DrawSettings.vue?vue&type=template&id=704a1269&"
import script from "./DrawSettings.vue?vue&type=script&lang=js&"
export * from "./DrawSettings.vue?vue&type=script&lang=js&"
import style0 from "./DrawSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports